import React from 'react';
import Translations from '../../services/translation.service';
import CountrySelectBasic from '../shared/count-select-basic.component';
import hintImg from "../../assets/img/hint.svg";
import PhoneWrapper from '../shared/sharedFields/phoneWrapper';
// import CountrySelectModal from '../shared/country-select-modal.component';

let prefix2 = "3.3.2.B_";

const EligibilityPhone = (props) => {

    return (
        <div className="field-section">
            <div className="field-container">
                {props.countryDisabled ?
                <>
                    <PhoneWrapper>
                        <input
                            type="tel"
                            className={
                                "storefront-search-input " +
                                (!props.phone.touched || (props.phone.touched && props.phone.valid)
                                    ? "valid"
                                    : "invalid") +
                                (props.phone.value ? " filled" : "")
                            }
                            name="contact_number"
                            id="contact_number"
                            value={props.phone.value}
                            onChange={props.updateContactField}
                        />
                    </PhoneWrapper>
                </> :
                <div className="storefront-two-fields">
                    <div className={"country-select-container"}>
                        <CountrySelectBasic
                            form_id={'country_contact_user'}
                            defaultCountry={props.phoneCode.value}
                            field_name="country_select"
                            updateFieled={props.handleCountryCode}
                        />
                        {/* <CountrySelectModal
                            defaultCountry={props.phoneCode.value}
                            updateFieled={props.handleCountryCode} 
                        /> */}
                    </div>

                    <input
                        type="tel"
                        className={
                            "storefront-search-input " +
                            (!props.phone.touched || (props.phone.touched && props.phone.valid)
                                ? "valid"
                                : "invalid") +
                            (props.phone.value ? " filled" : "")
                        }
                        name="contact_number"
                        id="contact_number"
                        value={props.phone.value}
                        onChange={props.updateContactField}
                    />
                </div>
                }

                <div className="hint-section">
                    <img src={hintImg} alt="Message" />
                    <p>{Translations.keys[prefix2 + "enter_associated_num"]}</p>
                </div>
            </div>
        </div>
    )
}

export default EligibilityPhone;